import {
    Container,
    FormControl,
    FormControlLabel,
    FormGroup,
    Grid,
    Switch,
    Typography,
    Divider
} from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';
import React from "react";
import "../styles/deckCreationStyles.css";
import "../styles/masterStyles.css";
import { SaspButton } from "./SaspButton";
import { CounterWidget } from "./CounterWidget"
import ModalIcon from "../components/ModalIcon";

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
        maxWidth: 300,
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: 2,
        backgroundColor: '#00567a',
        color: '#fff' 
    },
    noLabel: {
        marginTop: theme.spacing(3),
    },
}));

function getStyles(index, key, theme) {
    return {
      fontWeight:
        key.indexOf(index) === -1
            ? theme.typography.fontWeightRegular
            : theme.typography.fontWeightMedium,
    };
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
        },
    },
};

export const ViewDeckForm = props => {
    const [name, changeName] = React.useState(props.name);
    const [summary, changeSummary] = React.useState(props.summary);
    const [checkYears, setCheckedYears] = React.useState(props.yearsObj);
    const [checkAreas, setCheckedAreas] = React.useState(props.areaObj);
    const [checkKeyword, setCheckedKeyword] = React.useState(props.keywords);
    const [myYears, setMyYears] = React.useState([]);
    const [myAreas, setMyAreas] = React.useState([]);
    const classes = useStyles();
    const selectYears = Object.keys(props.yearsObj);

    const [state, setState] = React.useState({
        isHome: props.isHome,
        openBook: props.openBook,
        isPublic: props.isPublic,
        isSpaced: props.isSpaced,
        questionCount: props.questionCount,
        name: props.name,
        summary: props.summary,
        questionObj: props.questionObj,
        yearText:props.yearText,
        areaText:props.areaText
    });

    const icon = props.icons;
    const indecks = props.deckList.filter(item => item.deckID === props.deckID);
    console.log("indecks:", indecks);

    return (
        <Container className="createDeckFormContainer" maxWidth="xl">
            <Grid container className="mainContainer margin-top-8">
                <Grid item xs={12} className="anchor margin-bottom-16">
                    {/* <CounterWidget 
                        count={props.questionCount}
                        textColor="#fff"
                        backgroundColor="#00567a"
                    />  */}
                    <Typography className="DividerText">{name}</Typography>
                    <Divider className="SASPDivider" />
                </Grid>

                <Grid item xs={12} className="margin-bottom-16 margin-top-12">
                    <div className="text-blue font-strong margin-bottom-4">Deck Summary</div>
                    <div>{summary}</div>
                </Grid>

                <Grid item xs={12} className="margin-bottom-16 margin-top-12">
                    <div className="text-blue font-strong margin-bottom-4">Subscription Years</div>
                    <div>{props.yearText()}</div>
                </Grid>

                <Grid item xs={12} className="margin-bottom-16">
                    <div className="text-blue font-strong margin-bottom-4">Topics</div>
                    <div>{props.areaText()}</div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={props.isHome} 
                                    name="isHome"  />}
                                    label="Add to Home"
                                    disabled={true}
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Home Deck'}
                            icon={'info'}
                            body={icon.home}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={props.openBook} 
                                    name="openBook"  />}
                                    label="Open Book"
                                    disabled={true}
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Open Book'}
                            icon={'info'}
                            body={icon.open}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <Grid item xs={12}>
                    <div className="row-set">
                        <FormControl component="fieldset">
                            <FormGroup>
                                <FormControlLabel
                                    control={<Switch checked={props.isSpaced} 
                                    name="isSpaced"  />}
                                    label="Spaced Learning"
                                    disabled={true}
                                />
                            </FormGroup>
                        </FormControl>

                        <ModalIcon
                            title={'Spaced Learning'}
                            icon={'info'}
                            body={icon.spaced}
                            color={'#7c878e'}
                            className={"margin-left-16"}
                        />
                    </div>
                </Grid>

                <div className="margin-top-48 margin-bottom-16" style={{
                    display:"flex",
                    justifyContent:"space-between",
                    alignItems: "center",
                    width: "100%"
                }}>
                    <SaspButton
                        className="text-white"
                        onClick={() => props.gapFunc({
                            copy: 1
                        })}
                    >
                        Copy Deck
                    </SaspButton>

                    {indecks.length > 0 ? (
                        <SaspButton
                            className="deleteButton"
                            onClick={() => props.gapFunc({
                                copy: 0
                            })}
                        >
                            Unsubscribe
                        </SaspButton>
                    ) : (
                        <SaspButton
                            className="text-white"
                            onClick={() => props.gapFunc({
                                copy: 0
                            })}
                        >
                            Subscribe
                        </SaspButton>
                    )}
                    
                </div>
            </Grid>
        </Container>
    );
};